import RegularizationSetting from "./regularizationSetting";
export default RegularizationSetting;